// extracted by mini-css-extract-plugin
export const card = "index-module--card--Ck9R-";
export const thumbnail = "index-module--thumbnail--29sFk";
export const fullsize = "index-module--fullsize--12Y9Q";
export const data = "index-module--data--SRcX9";
export const head = "index-module--head--3PK7_";
export const info = "index-module--info--1ArhH";
export const flex = "index-module--flex--2AZjw";
export const tag = "index-module--tag--7FHCq";
export const bottom1 = "index-module--bottom1--gs0x-";
export const bottom2 = "index-module--bottom2--2xq_J";
export const bottom3 = "index-module--bottom3--3H_qb";
export const title = "index-module--title--3fbdv";
export const lead = "index-module--lead--1JlKJ";